export default function GrainOverlay() {
  return (
    <div
      className="fixed inset-0 z-[9999] pointer-events-none opacity-[0.04]"
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/noise.svg')`,
        backgroundRepeat: "repeat",
      }}
    />
  );
}
